import { EntityService } from './EntityService';
import { IEntity, INAODefForm } from '../types';

export class SectorService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/Sectors`);
    }

    public readAllForLookup(includeClosed?: boolean): Promise<IEntity[]> {
        return this.readAll();
    }
}